export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";